import {defineStore} from 'pinia'
import {markRaw} from 'vue'
import {useFormStore} from '@/stores/form'

export const useModalsStore = defineStore('modals', {
    state: () => ({
        nextId: 0,
        modals: [], // Automatically deeply reactive
    }),
    actions: {
        hideAll() {
            this.modals = []
        },
        pop() {
            this.modals.pop()
        },
        show({componentName, obj}) {
            const modal = {
                id: this.nextId++,
                componentName,
                show: false,
                // Prevents Vue from making the component definition deeply reactive
                options: markRaw(obj || {}),
                formId: ''
            }
            
            this.modals.push(modal)
            
            // Re-fetch from state array to guarantee proxy reference safety
            const target = this.modals.find(m => m.id === modal.id)
            
            setTimeout(() => {
                if (target) {
                    target.show = true // Triggers reactive updates
                }
            }, 100)
            
            return target
        },
        remove(id) {
            const index = this.modals.findIndex(m => m.id === id)
            if (index === -1) return
            
            const modal = this.modals[index]
            
            if (modal?.formId) {
                const formStore = useFormStore(modal.formId)
                
                if (formStore.isModified) {
                    this.show({
                        componentName: 'ConfirmModal',
                        obj: {
                            modalTitle: 'Are you sure?',
                            modalBody: `
                                <p class="alert alert-danger">
                                    Your unsaved changes will be lost.
                                </p>
                            `,
                            onConfirm: () => {
                                // Re-evaluate index at execution time
                                const currentIndex = this.modals.findIndex(m => m.id === id)
                                if (currentIndex !== -1) {
                                    this.modals.splice(currentIndex, 1)
                                }
                            }
                        }
                    })
                    return
                }
            }
            
            this.modals.splice(index, 1)
        }
    }
})